export const CLOSE_TIME_MS = 8000;
export type NotificationType = 'prompt' | 'message' | 'async';
export type NotificationThemeType = 'error' | 'info' | 'success' | 'warning' | 'prompt' | 'updates' | 'tasks';
